export default __webpack_public_path__ + "static/media/Delete Action Icon Component.b5a07233.svg";